/**
 * Custom error classes for better error classification
 * These help distinguish between expected validation errors and unexpected system errors
 */

/**
 * ValidationError - Thrown for user-facing validation failures
 * These errors are already handled by UI (toasts) and should NOT be logged to security
 */
export class ValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
  }
}

/**
 * Check if an error is a ValidationError
 */
export const isValidationError = (error: unknown): error is ValidationError => {
  return error instanceof Error && error.name === 'ValidationError';
};
